import axios from 'axios';
import { BACKEND_ENDPOINT } from '../config/authConfig';

const axiosClient = axios.create({
  baseURL: BACKEND_ENDPOINT,
  withCredentials: true,
});

export default axiosClient;
